import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// validation function
export function validateSSNFactory(): ValidatorFn {
    return (c: AbstractControl): ValidationErrors | null => {
        let result = null;
        const ssnRegExp = /(^(\d|\*){3}-?(\d|\*){2}-?(\d|\*){4}$|^XXX-XX-XXXX$)/g;
        const isValid = c.value === null || c.value === '' || ssnRegExp.exec(c.value);

        if (!isValid) {
            result = {
                aixSSN: {
                    valid: false
                }
            };
        }

        return result;
    };
}
